/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTrendsSkeleton.defs.js'
export { main as default } from './getTrendsSkeleton.defs.js'
